module.exports = __webpack_public_path__ + "img/onboarding.efdd8a05.png";